<template>
    <div class='card_bg'>
      <div class='tips'>{{$t('message.ready_to_swap')}}</div>
      <div class='depositInfo_bg'>
        <div class='depositInfo_title'>{{this.$t('message.transfer_prefix', {token: getTokenDesc})}}</div>
        <div class="addressAndMemoRaw">
          <div class='depositInfo_title'>{{this.$t('message.address')}}:&nbsp;</div>
          <div class="depositInfo_desc">{{getDepositAddress()}}</div>
        </div>
        <template v-if="checkIsNeedMemo()">
          <div class="addressAndMemoRaw">
            <div class='depositInfo_title'>{{this.$t('message.memo')}}:&nbsp;</div>
            <div class="depositInfo_desc">{{getTransferMemo()}}</div>
          </div>
        </template>
      </div>
      <div class="autoSwapDesc" v-html="getAutoSwapDesc()"></div>
      <div class="swapAddressBg">
        <div class="addressAndMemoRaw">
          <div class='swapAddress_title'>{{getSwapAddressDesc()}}:&nbsp;</div>
          <div class='swapAddress_desc'> {{getSwapAddress()}}</div>
        </div>
        <template v-if="checkHasExchangeMemo()">
          <div class="addressAndMemoRaw">
            <div class='swapAddress_title'>{{this.$t('message.memo')}}:&nbsp;</div>
            <div class='swapAddress_desc'> {{getExchangeMemo()}}</div>
          </div>
        </template>
      </div>

      <addressWarning />
      <fee-notice v-if="serviceFee > 0"
        :token="getTokenDesc"
        :fee="serviceFee"
      />
    </div>
</template>

<script>
import utils from '../common/utils'
import feeNotice from './feeNotice.vue'
import addressWarning from './addressWarning.vue'
export default {
  name: 'depositInfoView',
  components: { feeNotice, addressWarning },
  props: {
    depositInfo: {
      type: Object,
      default: function () {
        return { SwapType: -1, depositAddress: '', memo: '', swapAddress: '', exChangeBnbMemo: '' }
      }
    }
  },
  data () {
    return {

    }
  },
  methods: {
    // getTokenDesc () {
    //   let key = utils.swapTypeKey
    //   if (this.depositInfo.hasOwnProperty(key)) {
    //     let swapType = this.depositInfo[key]
    //     if (utils.checkIsErc20Swap(swapType)) {
    //       return this.$t('message.erc20_token')
    //     } else if (utils.checkIsBep2Swap(swapType)) {
    //       return this.$t('message.bep2_token')
    //     } else if (utils.checkIsCosMainNetSwap(swapType)) {
    //       return this.$t('message.main_net_token')
    //     }
    //   }
    //   return ''
    // },
    getDepositAddress () {
      let key = utils.addressKey
      if (this.depositInfo.hasOwnProperty(key)) {
        return this.depositInfo[key]
      }
      return ''
    },
    getTransferMemo () {
      let key = utils.memoKey
      if (this.depositInfo.hasOwnProperty(key)) {
        return this.depositInfo[key]
      }
      return ''
    },
    checkIsNeedMemo () {
      let key = utils.swapTypeKey
      if (this.depositInfo.hasOwnProperty(key)) {
        let swapType = this.depositInfo[key]
        if (utils.checkIsErc20Swap(swapType) || utils.checkIsBep20Swap(swapType)) {
          return false
        } else {
          return true
        }
      }
      return false
    },

    getSwapAddressDesc () {
      let key = utils.swapTypeKey
      if (this.depositInfo.hasOwnProperty(key)) {
        let swapType = this.depositInfo[key]
        if (utils.checkIsSwapToErc20(swapType)) {
          return this.$t('message.erc20_address')
        } else if (utils.checkIsSwapToBep2(swapType)) {
          return this.$t('message.bep2_address')
        } else if (utils.checkIsSwapToCosMainNet(swapType)) {
          return this.$t('message.main_net_address')
        } else if (utils.checkIsSwapToBep20(swapType)) {
          return this.$t('message.bep20_address')
        }
      }
      return ''
    },

    getSwapAddress () {
      let key = utils.swapAddressKey
      if (this.depositInfo.hasOwnProperty(key)) {
        return this.depositInfo[key]
      }
      return ''
    },

    checkHasExchangeMemo () {
      let key = utils.exChangeMemo
      if (this.depositInfo.hasOwnProperty(key)) {
        let memo = this.depositInfo[key]
        if (memo.length > 0) {
          return true
        }
      }
      return false
    },

    getExchangeMemo () {
      let key = utils.exChangeMemo
      if (this.depositInfo.hasOwnProperty(key)) {
        return this.depositInfo[key]
      }
      return ''
    },

    getStartSwapTips () {
      return 'After the transfer is complete, you need to wait for about 2~3 minutes, we will automatically verify your' +
        ' transaction, and the conversion will be completed automatically after the transaction is successful.'
    },

    getAutoSwapDesc () {
      // return 'Make sure you enter the ADDRESS and MEMO correctly.Swap token utility will send out the corresponding ' +
      //   'amount of COS token below wallet once receiving your token.The process may take about 5 minutes.'
      if (this.checkIsNeedMemo()) {
        return this.$t('message.auto_swap_desc_memo')
      } else {
        return this.$t('message.auto_swap_desc')
      }
    }

  },

  computed: {
    getTokenDesc () {
      let key = utils.swapTypeKey
      if (this.depositInfo.hasOwnProperty(key)) {
        let swapType = this.depositInfo[key]
        if (utils.checkIsErc20Swap(swapType)) {
          return this.$t('message.erc20_token')
        } else if (utils.checkIsBep2Swap(swapType)) {
          return this.$t('message.bep2_token')
        } else if (utils.checkIsBep20Swap(swapType)) {
          return this.$t('message.bep20_token')
        } else if (utils.checkIsCosMainNetSwap(swapType)) {
          return this.$t('message.main_net_token')
        }
      }
      return ''
    },
    serviceFee () {
      return utils.serviceFee(this.depositInfo[utils.swapTypeKey])
    }
  }
}
</script>

<style scoped>
  .card_bg {
    width: 50%;
    display: flex;
    display: -ms-flex;
    flex-direction: column;
    justify-items: left;
    justify-content: left;
    padding: 30px;
    box-sizing: border-box;
    border: 1px solid #007bff;
    border-radius: 4px;
    margin-bottom: -35px;
    /*word-break: break-word;*/
    /*word-wrap: break-word;*/
  }

  .tips {
    color: black;
    font-weight: bold;
    font-size: 18px;
    text-align: center;
  }

  .depositInfo_bg {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    font-size: 16px;
    text-align: left;
  }

  .depositInfo_title {
    text-align: left;
    color: black;
    margin-bottom: 18px;
    white-space:nowrap;
  }

  .depositInfo_desc {
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    color: black;
    margin-bottom: 18px;
    word-break: break-word;
    word-wrap: break-word;
  }

  .addressAndMemoRaw {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
  }

  .autoSwapDesc {
    margin-top: 20px;
    font-size: 15px;
    text-align: left;
  }

  .swapAddressBg {
    margin-top: 20px;
    text-align: left;
  }

  .swapAddress_title {
    font-size: 13px;
    color: black;
    white-space: nowrap;
  }

  .swapAddress_desc {
    font-size: 13px;
    color: black;
    font-weight: bold;
    word-break: break-word;
    word-wrap: break-word;
  }

  @media (max-width: 768px) {
    .card_bg {
      width: 80%;
    }
  }

</style>
